// extracted by mini-css-extract-plugin
export var LocationSection = "locationSelect-module--LocationSection--3lE2s";
export var CalculatorTitle = "locationSelect-module--CalculatorTitle--2UWtn";
export var LocationParent = "locationSelect-module--LocationParent--2QYUy";
export var Div1 = "locationSelect-module--Div1--ypVj_";
export var Div2 = "locationSelect-module--Div2--2jeIR";
export var Div3 = "locationSelect-module--Div3--1L_p4";
export var Div4 = "locationSelect-module--Div4--3LR9i";
export var InfoDisplay = "locationSelect-module--InfoDisplay--31Jwm";
export var MapDisplay = "locationSelect-module--MapDisplay--18h4u";
export var LocationImage = "locationSelect-module--LocationImage--30xKQ";
export var FilterChoices = "locationSelect-module--FilterChoices--2ExKr";
export var FilterBtns = "locationSelect-module--FilterBtns--1o5mz";
export var LocationChoices = "locationSelect-module--LocationChoices--3pIqa";
export var ItemContainer = "locationSelect-module--ItemContainer--Da5P6";
export var Dot = "locationSelect-module--Dot--1OwsU";
export var Text = "locationSelect-module--Text--3frPX";
export var LocationSelect = "locationSelect-module--LocationSelect--24nJF";
export var Container = "locationSelect-module--Container--2Jyuh";
export var Right = "locationSelect-module--Right--GFvfV";
export var RightTop = "locationSelect-module--RightTop--3liDz";
export var RightBottom = "locationSelect-module--RightBottom--12_si";
export var LocationsFilter = "locationSelect-module--LocationsFilter--2SCNL";